import Filter5Icon from '@mui/icons-material/Filter5';
import LoopIcon from '@mui/icons-material/Loop';
import PeopleIcon from '@mui/icons-material/People';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

export const VISUALIZE_MULTIPLE_CALENDAR = 'VISUALIZE_MULTIPLE_CALENDAR';

// The translation function has to be "_" in order for python-babel to find the strings needing to be translated
export const SUPPORT_CONTENT_MAP = {
  [VISUALIZE_MULTIPLE_CALENDAR]: (_) => ({
    title: _('View the agenda of several practitioners'),
    hintList: [
      {
        icon: PeopleIcon,
        title: _('Who are the listed users?'),
        text: _('This enumerates all the practitioners who have delegated their calendar management to you.'),
      },
      {
        icon: PersonAddIcon,
        title: _('How can I add a practitioner’s calendar to the multiple view?'),
        text: _('When moving your mouse over a practitioner’s avatar or initials, you can tick a checkbox to add their events to the multiple view. Un-tick it to hide them.'),
      },
      {
        icon: Filter5Icon,
        title: _('How many calendar can I view at the same time?'),
        text: _('For readability’s sake, only up to 5 simultaneously.'),
      },
      {
        icon: LoopIcon,
        title: _('What happens if I select a 6th practitioner?'),
        text: _('That user will be added to the list of visible calendars and the first one you have ticked (in a chronological order) will be hidden from the multiple view.'),
      },
    ],
  }),
};
